import { makeTokenizedRequest } from '../../utils/request-utils';
var STOP_STREAM_CONTENT_TYPE = 'application/vnd.stopstream.v1+json';
export default function stopStreamRequest(userToken, _a, _b, logger) {
    var timeouts = _a.timeouts, headers = _a.headers;
    var streamPosition = _b.streamPosition, url = _b.url;
    var payload = {
        streamPosition: streamPosition,
    };
    var requestParams = makeTokenizedRequest(STOP_STREAM_CONTENT_TYPE, "PUT" /* HTTPMethods.PUT */, headers, userToken, timeouts, payload, logger);
    requestParams.statusCodeCheck = false;
    return [url, requestParams];
}
//# sourceMappingURL=stop-stream-request.js.map